import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_blue",
  "use": "icon-arrow_blue-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow_blue\">\n    <path d=\"M8 12C7.83324 12 7.67344 11.9302 7.55671 11.8063L2.1774 6.09747C1.93744 5.84285 1.94142 5.4341 2.18625 5.18454C2.43106 4.935 2.82406 4.9391 3.06398 5.19374L8 10.4321L12.936 5.19374C13.1759 4.93908 13.5689 4.93492 13.8137 5.18454C14.0586 5.43413 14.0625 5.84285 13.8226 6.09747L8.44328 11.8063C8.32655 11.9302 8.16678 12 8 12Z\" fill=\"#2648FF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol